import { InputHTMLAttributes, ReactNode } from 'react';

interface InputNBProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export default function InputNB({
  label,
  error,
  className = '',
  id,
  ...props
}: InputNBProps) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label
          htmlFor={inputId}
          className="font-nb font-bold text-sm text-nb-black"
        >
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`
          bg-nb-white
          border-3 border-nb-black
          px-4 py-3
          rounded-[2px]
          font-nb
          focus:border-nb-yellow
          focus:outline-none
          ${error ? 'border-nb-red' : ''}
          ${className}
        `.replace(/\s+/g, ' ').trim()}
        {...props}
      />
      {error && (
        <span className="text-xs text-nb-red">{error}</span>
      )}
    </div>
  );
}